<template>
    <div class="customer-service">
        <!-- 入口已移到右侧悬浮栏的「客服」，此处只保留弹出面板，通过事件总线打开 -->

        <!-- 弹出的客服面板，内嵌腾讯云智能客服组件 -->
        <div class="cs-panel" v-show="showPanel">
            <div class="cs-header">
                <span>在线客服</span>
                <i class="el-icon-close" @click="showPanel = false"></i>
            </div>
            <div class="cs-content">
                <CustomerServiceChat v-if="inited" :style="{ width: '100%', height: '100%' }" />
            </div>
        </div>

        <div class="cs-mask" v-show="showPanel" @click="showPanel = false"></div>
    </div>
</template>

<script lang="ts">
// 注意：必须显式指向 index.ts。该目录下同时存在空的 index.vue 占位文件，
// 而本项目 resolve.extensions 中 .vue 排在 .ts 之前，若写成目录会错误解析到 index.vue，
// 导致默认导出是空组件、报 "init is not a function"。
import TUICustomerServer, { CustomerServiceChat } from "@/ai-desk-customer-vue/index.ts";
import vue from "@/ai-desk-customer-vue/adapter-vue";
// 浏览器端可用的 userSig 生成器（内置 HMAC-SHA256，无需 Node crypto），仅用于联调
import { genTestUserSig } from "@/TUIKit/debug/GenerateTestUserSig.js";
import Bus from "@/utils/bus";
import { setWithExpiry, getWithExpiry } from '@/utils/storage-ttl'; // 本地存储加时效性封装文件
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const {
    ref,
    watch,
    onMounted,
    onUnmounted
  } = vue;

  // ====== 腾讯云智能客服凭证 ======
  // SDKAppID：开通了智能客服 Desk 的应用 ID
  // userID：用户标识（不能包含 "administrator"）
  // SecretKey：⚠️ 仅用于联调！此处用密钥在前端本地生成 userSig，会把密钥打包进前端代码，
  //            存在泄露风险。生产环境务必改为「由你们服务端用密钥生成 userSig 后下发」，
  //            前端不得出现 SecretKey。

  const SDKAppID = 1600147122;
  var userID = null;
  const SecretKey = "9a44853ab1a3064c10165075c4e9036f3db7995aef84d881bbc258799f1d9ecb";
  function generateRandomNumber() {
    try {
      let result = '';
      // 第一位: 1 ~ 9 (不能为0)
      const firstDigit = Math.floor(Math.random() * 9) + 1;
      result += firstDigit.toString();

      // 剩余 11 位: 0 ~ 9
      for (let i = 0; i < 11; i++) {
        const digit = Math.floor(Math.random() * 10);
        result += digit.toString();
      }

      // 防御: 确保长度是12
      if (result.length !== 12) {
        // 极低概率的意外，递归重试一次 (但几乎不会触发)
        console.warn('生成长度异常，重试');
        return generateRandomNumber();
      }
      return result;
    } catch (e) {
      console.error('生成随机数出错:', e);
      return null;
    }
  }
  if (getWithExpiry('logInInfo')) {
    userID = getWithExpiry('logInInfo').memberCode;
  } else {
    userID = generateRandomNumber();
  }
  const showPanel = ref(false);
  const inited = ref(false);

  // 广播面板开/关状态：供独立客服页(customerWidget.vue)联动 iframe 尺寸用。
  // App.vue 中的常规用法不监听该事件，不受影响。
  watch(showPanel, v => Bus.$emit("customerServicePanelState", v));

  // 首次打开面板时再初始化并建立连接，避免每次进入站点都连接 IM
  const openChat = async () => {
    try {
      const {
        userSig
      } = genTestUserSig({
        SDKAppID,
        secretKey: SecretKey,
        userID
      });
      console.log("[在线客服] userSig 生成成功, 长度:", userSig && userSig.length);
      // 先渲染组件再 init，组件挂载后会监听会话 store；init 内部登录成功后写入会话
      inited.value = true;
      await TUICustomerServer.init(SDKAppID, userID, userSig);
      const loggedIn = TUICustomerServer.getLoggedInUserID && TUICustomerServer.getLoggedInUserID();
      console.log("[在线客服] init 完成, 当前登录用户ID:", loggedIn || "(空 → 登录失败，请检查 SDKAppID / SecretKey 是否匹配且已开通智能客服)");
    } catch (e) {
      console.error("[在线客服] 初始化异常:", e);
    }
  };

  // 由右侧悬浮栏「客服」通过事件总线触发打开
  const openPanel = () => {
    showPanel.value = true;
    if (!inited.value) {
      openChat();
    }
  };
  onMounted(() => {
    Bus.$on("openCustomerService", openPanel);
  });
  onUnmounted(() => {
    Bus.$off("openCustomerService", openPanel);
  });
  return {
    showPanel,
    inited
  };
};
__sfc_main.components = Object.assign({
  CustomerServiceChat
}, __sfc_main.components);
export default __sfc_main;
</script>

<style scoped>
.customer-service {
    position: fixed;
    right: 20px;
    bottom: 100px;
    z-index: 9999;
}

.cs-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background: linear-gradient(135deg, #005fc4, #58a1ff);
    border-radius: 50%;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 95, 196, 0.4);
    transition: all 0.3s ease;
    flex-direction: column;
    padding: 5px;
}

.cs-btn:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(0, 95, 196, 0.6);
}

.cs-btn i {
    font-size: 20px;
    margin-bottom: 2px;
}

.cs-btn span {
    font-size: 10px;
}

.cs-panel {
    position: absolute;
    right: 0;
    bottom: 80px;
    width: 360px;
    height: 480px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    overflow: hidden;
    animation: slideUp 0.3s ease;
    /* 必须高于 .cs-mask(9998)，否则聊天窗口会被背景遮罩盖住 */
    z-index: 10000;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.cs-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    background: linear-gradient(135deg, #005fc4, #58a1ff);
    color: #fff;
    font-size: 16px;
    font-weight: 500;
}

.cs-header i {
    cursor: pointer;
    font-size: 18px;
    transition: opacity 0.2s;
}

.cs-header i:hover {
    opacity: 0.8;
}

.cs-content {
    height: calc(100% - 48px);
}

.cs-mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 9998;
}

@media (max-width: 420px) {
    .cs-panel {
        width: 90vw;
        height: 94vh;
        right: 5vw;
    }

    .customer-service {
        right: 10px;
        bottom: -65px;
    }
}
</style>
